module.exports = __webpack_public_path__ + "img/try.387b225b.png";